<template>
	<div>
	<el-dialog
		:title="isEdit ? '编辑账号' : '添加账号'"
		:visible.sync="dialogVisible"
		width="550px"
		:close-on-click-modal="false"
		@close="handleClose"
	>
		<el-form ref="form" :model="form" :rules="formRules" label-width="80px">
			<el-form-item label="账号" prop="username">
				<el-input v-model="form.username" placeholder="请输入账号，3~20位，支持英文/数字等" maxlength="30" clearable :disabled="isEdit">
                    <div slot="prepend" v-if="!isEdit">
                        {{ userInfo.mobile }}:
                    </div>
                </el-input>
			</el-form-item>
			<el-form-item label="密码" prop="password" :required="!isEdit">
				<el-input
					v-model="form.password"
					type="password"
					:placeholder="isEdit ? '不修改请留空' : '请输入密码，6~20位，不能为纯字母或纯数字'"
					maxlength="30"
					clearable
					show-password
				>
				</el-input>
			</el-form-item>
			<el-form-item label="确认密码" prop="confirmPassword" :required="!isEdit">
				<el-input
					v-model="form.confirmPassword"
					type="password"
					placeholder="请再次输入密码"
					maxlength="30"
					clearable
					show-password
				>
				</el-input>
			</el-form-item>
			<el-form-item label="状态" prop="status">
                <el-switch v-model="form.status" :active-value="1" :inactive-value="0"></el-switch>
				<!-- <el-radio-group v-model="form.status">
					<el-radio :label="1">启用</el-radio>
					<el-radio :label="0">禁用</el-radio>
				</el-radio-group> -->
			</el-form-item>
			<el-form-item label="备注" prop="remark">
				<el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注" maxlength="200" show-word-limit />
			</el-form-item>
		</el-form>
		<div slot="footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" :loading="submitting" @click="handleSubmit">确 定</el-button>
		</div>
	</el-dialog>

	<!-- 密码展示弹窗 -->
	<el-dialog
		title="账号信息"
		:visible.sync="pwdDialogVisible"
		width="450px"
		:close-on-click-modal="false"
		:show-close="true"
	>
		<el-alert
			title="出于安全考虑，密码不再被明文保存，忘记密码请重新设置"
			type="warning"
			:closable="false"
			show-icon
			style="margin-bottom: 12px;"
		/>
		<el-descriptions :column="1" border>
            <el-descriptions-item label="登录地址">{{ loginUrl }}</el-descriptions-item>
			<el-descriptions-item label="账号">{{ pwdInfo.username }}</el-descriptions-item>
			<el-descriptions-item label="密码">{{ pwdInfo.password }}</el-descriptions-item>
		</el-descriptions>
		<div slot="footer">
			<el-button type="primary" @click="handleCopyPwd">一键复制</el-button>
			<el-button @click="pwdDialogVisible = false">关 闭</el-button>
		</div>
	</el-dialog>
	</div>
</template>

<script>
import { subAccountAdd, subAccountEdit } from '@/api/public'

export default {
	name: 'SubAccountDialog',
	data() {
		return {
			dialogVisible: false,
			isEdit: false,
			submitting: false,
			showPwd: false,
			editId: null,
			pwdDialogVisible: false,
			pwdInfo: { username: '', password: '' },
			form: {
				username: '',
				password: '',
				confirmPassword: '',
				status: 1,
				remark: ''
			},
		}
	},
	computed: {
		formRules() {
			const validatePassword = (rule, value, callback) => {
				if (!value) {
					if (this.isEdit) {
						// 编辑模式密码可不填，留空直接通过
						callback()
					} else {
						callback(new Error('请输入密码'))
					}
					return
				}
				if (value.length < 6 || value.length > 20) {
					callback(new Error('密码长度需在 6 到 20 个字符之间'))
					return
				}
				if (/^[a-zA-Z]+$/.test(value)) {
					callback(new Error('密码不能为纯字母'))
					return
				}
				if (/^[0-9]+$/.test(value)) {
					callback(new Error('密码不能为纯数字'))
					return
				}
				callback()
			}
			const usernameRules = this.isEdit ? [] : [
				{ required: true, message: '请输入账号', trigger: 'blur' },
				{ min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' },
				{ pattern: /^[^\u4e00-\u9fa5]+$/, message: '账号不能包含中文', trigger: 'blur' }
			]
			const validateConfirmPassword = (rule, value, callback) => {
				if (!value) {
					if (this.isEdit && !this.form.password) {
						callback()
					} else {
						callback(new Error('请再次输入密码'))
					}
					return
				}
				if (value !== this.form.password) {
					callback(new Error('两次输入的密码不一致'))
					return
				}
				callback()
			}
			return {
				username: usernameRules,
				password: [
					{ validator: validatePassword, trigger: 'blur' }
				],
				confirmPassword: [
					{ validator: validateConfirmPassword, trigger: 'blur' }
				],
				status: [{ required: true, message: '请选择状态', trigger: 'change' }]
			}
		},
        userInfo() {
			return this.$store.getters.info
		},
        siteCfg() {
			return this.$store.getters.config
		},
        loginUrl() {
            console.log(window)
            if (this.siteCfg && this.siteCfg.domain) {
                return this.siteCfg.domain
            } else {
                return `http://${window.xid}.webtool.hndhsoft.cn`
            }
        }
	},
	methods: {
		/** 打开新增弹窗 */
		openAdd() {
			this.isEdit = false
			this.editId = null
			this.form = { username: '', password: '', confirmPassword: '', status: 1, remark: '' }
			this.dialogVisible = true
			this.$nextTick(() => {
				this.$refs.form && this.$refs.form.clearValidate()
			})
		},
		/** 打开编辑弹窗 */
		openEdit(row) {
			this.isEdit = true
			this.editId = row.id
			this.form = {
				username: row.username || '',
				password: '',
				confirmPassword: '',
				status: row.status,
				remark: row.remark || ''
			}
			this.dialogVisible = true
			this.$nextTick(() => {
				this.$refs.form && this.$refs.form.clearValidate()
			})
		},
		handleClose() {
			this.$refs.form && this.$refs.form.resetFields()
			this.showPwd = false
		},
		handleSubmit() {
			this.$refs.form.validate(valid => {
				if (!valid) return
				if (this.isEdit) {
					this.doEdit()
				} else {
					this.doAdd()
				}
			})
		},
		doAdd() {
			this.submitting = true
			subAccountAdd({
				username: this.form.username,
				password: this.form.password,
				status: this.form.status,
				remark: this.form.remark
			}).then(() => {
				this.dialogVisible = false
				this.$emit('success')
				// 先弹出密码弹窗，再延迟显示成功提示（message 会浮在弹窗之上）
                let username = `${this.userInfo.mobile}:${this.form.username}`
				this.showPwdDialog(username, this.form.password)
				setTimeout(() => {
					this.$message.success('添加成功')
				}, 300)
			}).catch(() => {}).finally(() => {
				this.submitting = false
			})
		},
		doEdit() {
			this.submitting = true
			const params = {
				id: this.editId,
				status: this.form.status,
				remark: this.form.remark
			}
			// 仅当填写了密码时才传
			if (this.form.password) {
				params.password = this.form.password
			}
			subAccountEdit(params).then(() => {
				this.dialogVisible = false
				this.$emit('success')
				if (this.form.password) {
					this.showPwdDialog(this.form.username, this.form.password)
				}
                setTimeout(() => {
                    this.$message.success('编辑成功')
                }, 300)
			}).catch(() => {}).finally(() => {
				this.submitting = false
			})
		},
		showPwdDialog(username, password) {
			this.pwdInfo = { username, password }
			this.pwdDialogVisible = true
		},
		handleCopyPwd() {
			const text = `登录地址：${this.loginUrl}\n账号：${this.pwdInfo.username}\n密码：${this.pwdInfo.password}`
			this.$copyText(text).then(() => {
				this.$message.success('复制成功')
                this.pwdDialogVisible = false
			}).catch(() => {
				this.$message.error('复制失败，请手动复制')
			})
		}
	}
}
</script>
